'use es6';

import { PureComponent } from 'react';
import { NavMarker } from 'react-rhumb';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIButton from 'UIComponents/button/UIButton';
import UIEmptyState from 'UIComponents/empty/UIEmptyState';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getI18nKey = suffix => `FileManagerDashboard.noAccess.${suffix}`;
export default class DashboardNoAccess extends PureComponent {
  render() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "DASHBOARD_NO_ACCESS"
      }), /*#__PURE__*/_jsx(UIEmptyState, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getI18nKey('header')
        }),
        primaryContent: /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          href: `/reports-dashboard/${PortalIdParser.get()}/marketing`,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: getI18nKey('button')
          })
        }),
        secondaryContent: /*#__PURE__*/_jsx(UIIllustration, {
          name: "lock",
          width: "100%"
        }),
        secondaryContentWidth: 100
      })]
    });
  }
}